var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.002,
    height: 34.667,
    viewBox: "0 0 26.002 34.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M16.607,0H.724a.75.75,0,0,0,0,1.5H16.605a.75.75,0,0,0,0-1.5Z",
    transform: "translate(4.376 28.656)",
    fill: "#eb742e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2",
    "data-name": "Fill 2",
    d: "M16.607,0H.724a.75.75,0,0,0,0,1.5H16.605a.75.75,0,0,0,0-1.5Z",
    transform: "translate(4.376 24.614)",
    fill: "#eb742e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3",
    "data-name": "Fill 3",
    d: "M16.607,0H.724a.75.75,0,0,0,0,1.5H16.605a.75.75,0,0,0,0-1.5Z",
    transform: "translate(4.376 20.57)",
    fill: "#eb742e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    "data-name": "Fill 4",
    d: "M0,.75a.747.747,0,0,0,.724.75H16.605a.75.75,0,0,0,0-1.5H.719A.741.741,0,0,0,0,.75Z",
    transform: "translate(4.38 16.527)",
    fill: "#eb742e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_5",
    "data-name": "Fill 5",
    d: "M24.255,34.667H1.816A1.847,1.847,0,0,1,0,32.838V1.739A1.781,1.781,0,0,1,1.816,0H14.442L26,11.5l0,21.338A1.791,1.791,0,0,1,24.255,34.667ZM2.661,1.386A1.181,1.181,0,0,0,1.5,2.583V31.989a1.155,1.155,0,0,0,1.161,1.175H23.405a1.193,1.193,0,0,0,1.209-1.175V11.558l-8.359,0a1.867,1.867,0,0,1-1.811-1.828V1.386Z",
    transform: "translate(0)",
    fill: "#eb742e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_6",
    "data-name": "Fill 6",
    d: "M3.89,7.782a.531.531,0,0,1-.361-.14l-.312-.281a.565.565,0,0,0-.477-.126l-.411.086a.555.555,0,0,1-.111.011A.543.543,0,0,1,1.7,6.958l-.13-.4a.535.535,0,0,0-.347-.346l-.4-.13A.545.545,0,0,1,.46,5.453l.086-.411A.535.535,0,0,0,.42,4.565L.14,4.253a.539.539,0,0,1,0-.724L.42,3.217A.566.566,0,0,0,.546,2.74L.46,2.328A.545.545,0,0,1,.824,1.7l.4-.13a.535.535,0,0,0,.347-.347l.13-.4A.543.543,0,0,1,2.217.449.555.555,0,0,1,2.328.46L2.74.546A.526.526,0,0,0,2.857.56.537.537,0,0,0,3.217.42L3.529.14a.538.538,0,0,1,.724,0L4.565.42a.562.562,0,0,0,.369.137A.562.562,0,0,0,5.042.546L5.453.46A.555.555,0,0,1,5.564.449a.543.543,0,0,1,.517.375l.13.4a.535.535,0,0,0,.346.347l.4.13a.545.545,0,0,1,.364.628l-.086.411a.535.535,0,0,0,.126.477l.281.312a.539.539,0,0,1,0,.724l-.281.312a.566.566,0,0,0-.126.477l.086.411a.545.545,0,0,1-.364.628l-.4.13a.535.535,0,0,0-.346.346l-.13.4a.543.543,0,0,1-.517.375.555.555,0,0,1-.111-.011l-.411-.086a.526.526,0,0,0-.117-.013.537.537,0,0,0-.36.139l-.312.281A.536.536,0,0,1,3.89,7.782ZM3.884.973a2.911,2.911,0,1,0,2.064.852A2.9,2.9,0,0,0,3.884.973Z",
    transform: "translate(4.38 3.102)",
    fill: "#eb742e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_7",
    "data-name": "Fill 7",
    d: "M2.812.411a.046.046,0,0,0-.025.005L2.375.5a.786.786,0,0,1-.2.022A.932.932,0,0,1,1.33,0L0,3.653l1.325-.672L1.911,4.35,3.225.736,3.211.723,2.9.442a.149.149,0,0,0-.088-.03Z",
    transform: "translate(4.416 10.308)",
    fill: "#eb742e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_8",
    "data-name": "Fill 8",
    d: "M1.053.532A.829.829,0,0,1,.853.5L.442.41C.433.41.425.4.416.4A.152.152,0,0,0,.325.438L.014.719,0,.733,1.314,4.347,1.9,2.977l1.325.672L1.894,0a.933.933,0,0,1-.841.532Z",
    transform: "translate(8.883 10.319)",
    fill: "#eb742e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_9",
    "data-name": "Fill 9",
    d: "M.848,4.225,2.223,3.5,3.6,4.225l-.259-1.53L4.445,1.611,2.911,1.39,2.223,0,1.537,1.39,0,1.611,1.114,2.695Z",
    transform: "translate(6.041 4.88)",
    fill: "#eb742e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketIcon);
export default __webpack_public_path__ + "static/media/ticket-icon.6b61269526c6f763743c94f3a5c5d0db.svg";
export { ForwardRef as ReactComponent };